import {
    workerActionInitialize,
    workerActionStartSinglePanelTypeGeneration,
    workerActionStartSingleCornerTypeGeneration,
    workerActionStartMissingModelGenerations,
    workerActionTrackUnprocessedTypes,
    workerResultSinglePanelTypeGenerationStarted,
    workerResultSingleCornerTypeGenerationStarted,
    workerResultMissingModelGenerationsStarted,
    workerResultGenerationCompleted,
    workerResultOperationFailed,
    workerActionAbortGenerationCheck,
} from "./constants/workerActionTypes";
import { WorkerAction, WorkerResultMessage } from "./generatedPanelsContentWorker";
import eventBus from "../eventBus/eventDispatcher";
import repo from "../../../Repository";

export class GeneratedPanelsContent {
    private readonly worker: Worker;

    constructor(readonly modelId: string) {
        this.worker = new Worker(new URL("./generatedPanelsContentWorker.ts", import.meta.url), { type: "module" });

        this.onWorkerMessage = this.onWorkerMessage.bind(this);
        this.worker.onmessage = this.onWorkerMessage;

        this.postWorkerMessage({ type: workerActionInitialize, accessToken: repo.getAccessToken(), modelId });
    }

    public startSinglePanelTypeGeneration(panelTypeId: string) {
        this.postWorkerMessage({
            type: workerActionStartSinglePanelTypeGeneration,
            panelTypeId,
        });
    }

    public startSingleCornerPanelTypeGeneration(cornerTypeId: string) {
        this.postWorkerMessage({
            type: workerActionStartSingleCornerTypeGeneration,
            cornerTypeId,
        });
    }

    public startMissingModelGenerations(modelId: string) {
        this.postWorkerMessage({
            type: workerActionStartMissingModelGenerations,
            modelId,
        });
    }

    public trackUnprocessed(panelTypeIds: string[], cornerTypeIds: string[]) {
        this.postWorkerMessage({
            type: workerActionTrackUnprocessedTypes,
            panelTypeIds,
            cornerTypeIds,
        });
    }

    public abortCheck(panelTypeId: string, isPanelModel: boolean) {
        this.postWorkerMessage({ type: workerActionAbortGenerationCheck, panelTypeId, isPanelModel });
    }

    private onWorkerMessage(event: MessageEvent<WorkerResultMessage>) {
        const data = event.data;

        switch (data.type) {
            case workerResultSinglePanelTypeGenerationStarted: {
                eventBus.dispatchEvent({
                    type: "Dextall.TypesManager.PanelType.SingleGeneration.Started",
                    payload: data.panelTypeId,
                });
                break;
            }

            case workerResultSingleCornerTypeGenerationStarted: {
                eventBus.dispatchEvent({
                    type: "Dextall.TypesManager.CornerType.SingleGeneration.Started",
                    payload: data.panelTypeId,
                });
                break;
            }

            case workerResultMissingModelGenerationsStarted: {
                eventBus.dispatchEvent({
                    type: "Dextall.TypesManager.GenerateAll.Started",
                    payload: data,
                });
                break;
            }

            case workerResultGenerationCompleted: {
                eventBus.dispatchEvent({
                    type: "Dextall.TypesManager.GenerationCompleted",
                    payload: data,
                });
                break;
            }

            case workerResultOperationFailed: {
                eventBus.dispatchEvent({
                    type: "Dextall.TypesManager.GenerationRequest.Failed",
                    payload: data,
                });
                break;
            }
        }
    }

    private postWorkerMessage(message: WorkerAction) {
        this.worker.postMessage(message);
    }
}
